import styled from 'styled-components';

import { GoogleAdsBannerProps } from '.';

export const Wrapper = styled.div<Omit<GoogleAdsBannerProps, 'slotId'>>`
  ins {
    display: inline-block;
    width: 100%;
    height: inherit;
    border: 1px solid ${({ theme }) => theme.colors.gray300};
  }
`;
